import './less/main.less';
import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router, browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import { AppContainer } from 'react-hot-loader';
import store from './store';
import routes from './routes';

const history = syncHistoryWithStore(browserHistory, store);

ReactDOM.render(
	<AppContainer>
		<Provider store={store}>
			<Router history={history}>
				{routes}
			</Router>
		</Provider>
	</AppContainer>,
	document.getElementById('app')
);

if (module.hot && process.env.NODE_ENV === 'development') {
	module.hot.accept();
}



// WEBPACK FOOTER //
// ./frontend/cabinets/apps/everad/main.js